import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "guideTheme"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.themebg !== '' ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.themebg,
    alt: ""
  }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]);
}